module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('center', [_c('br'), _vm._v(" "), _c('h1', [_vm._v("Logged Out")]), _c('br'), _vm._v("\n  Thanks for using the system."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n  To log back in, "), _c('a', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("click here")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7acd78e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Logout.vue
// module id = 1731
// module chunks = 0